// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"db23be3c","57":"8db7d545","124":"2e9301af","353":"496a5887","449":"5243685d","453":"87e45203","660":"dff304d2","697":"9d3aaf3b","712":"78bb60f3","819":"d3b2aee9"}[chunkId] + ".chunk.js";
};